"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Life = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var systemTab_1 = require("../../model/systemTab");
var service_1 = require("../../../library/base/service");
var Life = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Life, _super);
    function Life() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '生活标签';
        _this.code = '100006';
        _this.desc = "";
        _this.requestParams = new systemTab_1.LifeRequest();
        // public responseParams: LoginResponse;
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Life;
}(service_1.BaseService));
exports.Life = Life;
//# sourceMappingURL=life.js.map